export function getNumberParam(searchString: string, name: string, defaultValue: number): number {
  const param = new URLSearchParams(searchString).get(name);
  if (param) {
    return parseInt(param, 10);
  }
  return defaultValue;
}
